import { 
  Gift,
  Wallet,
  TrendingDown,
  TrendingUp,
  Building2,
  Building,
  Home,
  GitMerge,
  CircleDot,
  CandlestickChart,
  Target,
  Goal,
  Banknote,
  LandPlot
} from 'lucide-react';

export const PortfolioTagIcons = {
  equity: () => <Gift size={18} />,
  fixed: () => <Wallet size={18} />,
  value: () => <TrendingDown size={18} />,
  growth: () => <TrendingUp size={18} />,
  large: () => <Building2 size={18} />,
  mid: () => <Building size={18} />,
  small: () => <Home size={18} />,
  blend: () => <GitMerge size={18} />,
  other: () => <CircleDot size={18} />,
  stock: () => <CandlestickChart size={18} />,
  focused: () => <Target size={18} />,
  outcome: () => <Goal size={18} />,
  bond: () => <Banknote size={18} />,
  government: () => <LandPlot size={18} />
};

// Usage example:
// import { PortfolioTagIcons } from './PortfolioTagIcons';
// const MyComponent = () => {
//   return <div>{PortfolioTagIcons.equity()}</div>;
// };